export default __webpack_public_path__ + "src/modules/CampaignsModule/components/HtmlUpload/icons/iconSignatures.svg";